import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';
import { GetTonePriceDto } from '../../../dto/gettoneprice/gettonepricedto';

export interface GetTonePriceResponse extends APIResponse
{
    getGetTonePriceDto(): GetTonePriceDto;
}

export class GetTonePriceResponseDtoImpl extends APIResponseDtoImpl implements GetTonePriceResponse
{
    private getTonePriceRespnseDto : GetTonePriceDto;

    getGetTonePriceDto(): GetTonePriceDto
    {
        return this.getTonePriceRespnseDto;
    }
    setTonePriceDto(getTonePriceRespnseDto: GetTonePriceDto)
    {
        this.getTonePriceRespnseDto = getTonePriceRespnseDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/gettuneprice/gettonepriceresponse.tsx